import { render, staticRenderFns } from "./DropdownTrigger.vue?vue&type=template&id=0fd0ef2e&"
import script from "./DropdownTrigger.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DropdownTrigger.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports